$(document).ready(function () {
  $('.banner_list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false
  });

  $(".reviews-slider").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          {
              breakpoint: 768,
              settings: {
              slidesToScroll: 1,
              slidesToShow: 1
              }
          }
        ]
  });

   $('.product-slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.products-slider-section .product-slider').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  
  $('.products-slider-section .product-slider').slick('refresh');
  
});

$(document).on('click','.select-label', function () {
    if($(this).parent().hasClass('active')){
      $(this).parent().removeClass('active');
    }else{
      $('.dropdown').removeClass('active');
      $(this).parent().addClass('active');
    }
});
$(document).on('click','.dropdown-list li', function () {
    $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
    $(this).parents('.dropdown').removeClass('active');
    var variant_id = $(this).data('value');
    $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
});

$(".jdgm-preview-badge").click(function(e) {
    e.preventDefault();
    $('.tab-container ul li:nth-child(2)').trigger('click');
    $('html, body').animate({
        scrollTop: $(".tab-container").offset().top
    }, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 550) {
    const headings = document.querySelectorAll('.footer-block__heading');

    headings.forEach(function (heading) {
      heading.addEventListener('click', function () {
        const content = this.nextElementSibling;

        this.classList.toggle('active');
        content.classList.toggle('active');
      });
    });
  }
});
// Fix: aria-hidden carousel items must not contain focusable elements (Judge.me)
(function () {
  var FOCUSABLE = 'a, button, input, select, textarea, [tabindex]';

  function applyTabindex(root) {
    root.querySelectorAll('[aria-hidden="true"]').forEach(function (hidden) {
      hidden.querySelectorAll(FOCUSABLE).forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
    });
    root.querySelectorAll('[aria-hidden="false"], .jdgm-carousel-item:not([aria-hidden])').forEach(function (visible) {
      visible.querySelectorAll('[tabindex="-1"]').forEach(function (el) {
        el.removeAttribute('tabindex');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyTabindex(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          applyTabindex(m.target.closest('.jdgm-widget') || document);
        }
      });
    });

    var widget = document.querySelector('.jdgm-widget, .jdgm-carousel');
    if (widget) {
      observer.observe(widget, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
    }
  });
})();